import { apiService } from "../../api/dataverseApi";
import { updateSingleCart, updateMultiCart } from "../../store/reducers/subscripion";

export const handleDeleteAction = async (cartsId, type, dispatch) => {
  try {
    const response = await apiService.deleteCartItem(cartsId);

    if (response.success) {
      if (type === "single") {
        dispatch(updateSingleCart({ cartsId: null, quantity: 0 }));
      } else if (type === "multiple") {
        dispatch(updateMultiCart({ cartsId: null, quantity: 0 }));
      }
      window.location.reload(); 
    }

    return response;
  } catch (error) {
    console.error("Failed to delete cart item:", error);
    throw error;
  }
}